jQuery( document ).ready(function($) {
  if($('.columnfooternew').length > 0) {

    $('.columnfooternew_trigger').on('click', (e) => {
      $('.columnfooternew_elements').slideToggle()
      if ($( '.columnfooternew_trigger span' ).html() == '+')  {
        $( '.columnfooternew_trigger span' ).html( '-' )
      }
      else {
        $( '.columnfooternew_trigger span' ).html( '+' )
      }
    })

  }
});